module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-arrow-up-597f1edf.svg";